const translations = {
  title: 'New destination',
  title_edit: 'Editing destination',
  bulkRegistration: 'Bulk registration',
  type: 'Type*',
  additionalFields: 'Additional fields'
}

export default translations
